export function isOptionalNotFound(error) {
  return error?.response?.status === 404;
}

export async function withOptionalFallback(request, fallbackData, isOptionalError = isOptionalNotFound) {
  try {
    return await request();
  } catch (error) {
    if (isOptionalError(error)) {
      return {
        data: fallbackData,
        status: 204,
        optional: true,
      };
    }
    throw error;
  }
}
